<template lang="html">
  <section class="clients">
    <h3 class="clients--no-results" v-if="clients.length === 0">
      {{ $t("generals.clientsfounded") }}
    </h3>
    <sui-grid
      v-else
      class="clients__container"
      :columns="columns === 4 ? 6 : 2"
      v-for="i in Math.ceil(clients.length / 6)"
      :key="i"
    >
      <sui-grid-row>
        <sui-grid-column
          v-for="(client, index) in clientsWithIndex.slice((i - 1) * 6, i * 6)"
          :key="index"
        >
          <transition-group
            name="staggered-fade"
            :css="false"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
            tag="div"
            class="clients__item"
          >
            <img
              v-show="visible"
              :src="client.image"
              :key="index"
              :data-index="client.index"
              :title="client.name"
              :alt="client.name"
            />
          </transition-group>
        </sui-grid-column>
      </sui-grid-row>
    </sui-grid>
  </section>
</template>

<script lang="js">
  import Velocity from "velocity-animate";

  export default  {
    name: 'clients',
    props: {
      clients: {
        type: Array,
        default: () => [],
      },
      columns: {
        type: Number,
      },
      visible: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        offset: 1,
        clientsCopy: [],
      }
    },

    computed: {
      clientsWithIndex() {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.clientsCopy = this.clients.map((item, index) => {

          return {
            ...item,
            index: index + 1,
          }
        });

        return this.clientsCopy;
      }
    },

    methods: {
      beforeEnter(el) {
        const $el = el;
        $el.style.opacity = 0;
      },

      enter(el, done) {
        const delay = el.dataset.index * 100;

        setTimeout(() => {
          Velocity(el, { opacity: 1 }, { complete: done });
        }, delay);
      },

      leave(el, done) {
        const delay = el.dataset.index * 80;

        setTimeout(() => {
          Velocity(el, { opacity: 0 }, { complete: done });
        }, delay);
      },
    },
}
</script>

<style scoped lang="scss">
.clients {
  &--no-results {
    color: white;
    width: 100%;
    text-align: center;
    font-weight: 300;
    font-size: 25px;
    max-width: 90%;
    margin: 0 auto;
  }
  img {
    width: 100%;
    margin-bottom: 20px;
  }

  &__item {
    margin-bottom: 30px;
  }
}

@media (max-width: 1000px) {
  .clients {
    &__item {
      margin-bottom: 0px;
    }

    .row {
      padding: 0 !important;
    }
  }
}
</style>
